import 'rc-calendar/dist/rc-calendar.css';
import { UserManager } from 'oidc-client';
import React from 'react';
import { render } from 'react-dom';
import { ApplicationAuthentication } from './Authentication/ApplicationAuthentication';
import { ApplicationRoot } from './Authentication/ApplicationRoot';
import './Styles/global.css';
import { LayoutCentral } from './Components/LayoutCentral';
import { LoadingPlaceholder } from './Components/Placeholder';
import MedicationsFeature from './App/MedicationsFeature';
import { ApplicationConfiguration, configureMedications, createUserManagerSettings } from './Config/ApplicationConfig';
import * as serviceWorker from './serviceWorker';

async function loadFont(fontName: string, woffUrl: string) {
    const localStoragePrefix = 'local-font-' + fontName;
    const localStorageUrlKey = localStoragePrefix + 'url';
    const localStorageCssKey = localStoragePrefix + 'css';
    const storedFontUrl = localStorage.getItem(localStorageUrlKey);
    const storedFontCss = localStorage.getItem(localStorageCssKey);
    const styleElement: HTMLStyleElement = document.createElement('style');
    document.head.appendChild(styleElement);

    if (storedFontCss && storedFontUrl === woffUrl) {
        styleElement.textContent = storedFontCss;
    } else {
        const url = woffUrl;

        const fontCss = await fetch(woffUrl).then(response => response.text());
        localStorage.setItem(localStorageUrlKey, url);
        styleElement.textContent = fontCss;
        localStorage.setItem(localStorageCssKey, fontCss);
    }
}

loadFont('sourceSansPro', '/fonts.woff.css');

async function boot() {
    let appConfig: ApplicationConfiguration;
    try {
        appConfig = await fetch('/configuration.json').then(response => response.json());
    } catch (err) {
        if (err instanceof Error) {
            throw new Error(`Unable/Parse config file: ${err.message}`);
        }

        throw err;
    }

    const userManager = new UserManager(createUserManagerSettings(appConfig));

    configureMedications({
        appConfig,
        userManager
    });

    render(
        <ApplicationAuthentication manager={userManager}>
            <ApplicationRoot
                root={MedicationsFeature}
                loadingSpinner={
                    <LayoutCentral>
                        <LoadingPlaceholder />
                    </LayoutCentral>
                }
            />
        </ApplicationAuthentication>,
        document.getElementById('root')
    );
}

boot();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
